var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConvert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    stroke: "#AF976E",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.499 16H5.49902V21M14.499 8H19.499V3M5.08203 9.0034C5.64272   7.61566 6.58146 6.41304 7.79157 5.53223C9.00169 4.65141 10.4359 4.12752    11.9288 4.02051C13.4217 3.9135 14.9138 4.2274 16.2371 4.92661C17.5605    5.62582 18.6603 6.68254 19.4131 7.97612M19.9166 14.9971C19.3559 16.3848    18.4171 17.5874 17.207 18.4682C15.9969 19.3491 14.5642 19.8723 13.0713    19.9793C11.5784 20.0863 10.0851 19.7725 8.76172 19.0732C7.43835 18.374    6.33785 17.3175 5.58496 16.0239",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConvert);
export default __webpack_public_path__ + "static/media/convert.2f1c43b4cc1ecdff0300a74fb1e5f0a1.svg";
export { ForwardRef as ReactComponent };